export default __webpack_public_path__ + "static/sunchasers-cebd778f78e75c70647af18885673ee8.webp";